import { PostEditorPostError, PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostEditorValidationMessages } from '../constants/validation-messages';
import { isAfter, parse, addSeconds } from 'date-fns';
import { DateTimeStringFormat } from 'constants/time-formats';
import { severityResolver } from './helpers/severity-resolver';
import { PostTiming } from '../../../models/graphql';
import { utcToZonedTime } from 'date-fns-tz';
import { TimezoneMap } from '../../../constants/timezones';

export const checkDateAndTime = (postGroup: PostGroupsType, severity: ErrorMessageSeverity): PostEditorPostErrors => {
  const { groupPostAttributes, customizeSchedulePerProfile } = postGroup;
  let results: PostEditorPostError[] = [];
  if (customizeSchedulePerProfile) {
    postGroup.posts.forEach(post => {
      const { scheduledLocalDateTimes, scheduledTimezone, postTiming, recurring } = post.scheduling;
      const isRecurring = postTiming === PostTiming.RECURRING && recurring.active && !!recurring.date;
      const isScheduling = postTiming === PostTiming.SCHEDULE;
      const now = addSeconds(new Date(), 60);
      if (isScheduling && scheduledTimezone) {
        const notPastScheduledDates = scheduledLocalDateTimes.filter(item => !item.isPast).map(item => item.dateTime);
        notPastScheduledDates.forEach((individualDate, index) => {
          const variationId = index + 1;
          const scheduledDate = parse(individualDate, DateTimeStringFormat, now);
          const tzDate = utcToZonedTime(now, TimezoneMap[scheduledTimezone]);
          if (!isAfter(scheduledDate, tzDate)) {
            results = [
              ...results,
              {
                profileId: post.customizedProfileId,
                variationId,
                severity: severityResolver(post, severity),
                selectedSocialProfiles: [],
                message: PostEditorValidationMessages.checkDateAndTime
              }
            ];
          }
        });
      } else if (isRecurring && recurring.date && scheduledTimezone) {
        const scheduledDate = parse(recurring.date, DateTimeStringFormat, now);
        const tzDate = utcToZonedTime(now, TimezoneMap[scheduledTimezone]);
        if (!isAfter(scheduledDate, tzDate)) {
          results = [
            ...results,
            {
              profileId: post.customizedProfileId,
              variationId: null,
              severity: severityResolver(post, severity),
              selectedSocialProfiles: [],
              message: PostEditorValidationMessages.checkDateAndTime
            }
          ];
        }
      }
    });
  } else {
    const { scheduledLocalDateTimes, scheduledTimezone, postTiming, recurring } = groupPostAttributes.scheduling;
    const isRecurring = postTiming === PostTiming.RECURRING && recurring.active && !!recurring.date;
    const isScheduling = postTiming === PostTiming.SCHEDULE;
    const now = addSeconds(new Date(), 60);
    if (isScheduling && scheduledTimezone) {
      const notPastScheduledDates = scheduledLocalDateTimes.filter(item => !item.isPast).map(item => item.dateTime);
      notPastScheduledDates.forEach((individualDate, index) => {
        const variationId = index + 1;
        const now = addSeconds(new Date(), 60);
        const scheduledDate = parse(individualDate, DateTimeStringFormat, now);
        const tzDate = utcToZonedTime(now, TimezoneMap[scheduledTimezone]);
        if (!isAfter(scheduledDate, tzDate)) {
          results = [
            ...results,
            {
              profileId: null,
              variationId,
              severity: severityResolver(postGroup.groupPostAttributes, severity),
              selectedSocialProfiles: [],
              message: PostEditorValidationMessages.checkDateAndTime
            }
          ];
        }
      });
    } else if (isRecurring && recurring.date && scheduledTimezone) {
      const scheduledDate = parse(recurring.date, DateTimeStringFormat, now);
      const tzDate = utcToZonedTime(now, TimezoneMap[scheduledTimezone]);
      return isAfter(scheduledDate, tzDate)
        ? false
        : {
            profileId: null,
            variationId: null,
            severity: severityResolver(postGroup.groupPostAttributes, severity),
            selectedSocialProfiles: [],
            message: PostEditorValidationMessages.checkDateAndTime
          };
    } else {
      return false;
    }
  }
  return results.length ? results : false;
};
